import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { GridActionsService } from 'src/app/data-grid/grid-actions.service';
import { GridApiService } from 'src/app/data-grid/grid-api.service';

@Component({
  selector: 'app-analytics-column-dropdown',
  templateUrl: './analytics-column-dropdown.component.html',
  styleUrls: ['./analytics-column-dropdown.component.scss']
})
export class AnalyticsColumnDropdownComponent implements OnInit,OnDestroy {
  columns;
  changesColumnState: boolean = false;
  gridOptions: any;
  groupNames:any[];
  private destroy$ = new Subject<void>();

  constructor(
    public gridActionsService: GridActionsService,
    private gridApiService: GridApiService,
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<AnalyticsColumnDropdownComponent>,
  ) {
    this.gridApiService.changedColumnState$.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.changesColumnState = e;
    });
  }

  ngOnInit(): void {
    this.gridOptions = this.data.gridOptions
    this.getColumns();
  }

  selectColumn(colId: any) {
    const isVisible = this.gridOptions.getColumn(colId)
      .isVisible();
    this.gridOptions.setColumnVisible(
      colId,
      !isVisible
    );
  }

  resetColumn() {
    this.gridActionsService.resetTable(this.data?.columnDefs);
    this.gridApiService.changedColumnState$.next(false);
    this.getColumns();
  }

  getColumns() {
    const columnsDef = this.gridOptions.getColumns();
    this.columns = columnsDef.reduce((currentValue, next:any) => {
      if (!currentValue.hasOwnProperty(next.userProvidedColDef.type)) {
        currentValue[next.userProvidedColDef.type] = [];
      }
      currentValue[next.userProvidedColDef.type].push(next);
      return currentValue;
    }, {});
    this.groupNames = Object.keys(this.columns);
  }

  filterItem(value) {
    if (value) {
      this.columns = this.columns.filter(
        (item) =>
          (item.userProvidedColDef.headerName
            ? item.userProvidedColDef.headerName
            : item.userProvidedColDef.field
          )
            .toLowerCase()
            .indexOf(value.toLowerCase()) > -1
      );
    } else {
      this.getColumns()
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
